import { createUpdateScenarioSettingUrl } from '../utils/createUpdateScenarioSettingsUrl';
import { makePatchRequest } from 'owa-ows-gateway';
import { TimePanelCalendarIdsRequestType } from '../schema/ScenarioSettings/TimePanelCalendarIds';

export async function updateTimePanelCalendarIdsService(
    calendarIds: string[],
    accountSmtpAddress: string
): Promise<void> {
    // CalendarIds are consistent across all modules, so we use the 'Owa' scenario
    const requestUrl = createUpdateScenarioSettingUrl('Owa', 'TimePanelCalendarIds');
    const timePanelCalendarIds: TimePanelCalendarIdsRequestType = { CalendarIds: calendarIds };
    await makePatchRequest(
        requestUrl,
        timePanelCalendarIds,
        undefined /* correlationId */,
        undefined /* returnFullResponse */,
        undefined /* customHeaders */,
        true /* throwServiceError */,
        undefined /* isThrottled */
    );
}
